<template>
	<div :class="classList" class="mock-el-select mock-el-select_container" @mouseenter="inputHovering = true" @mouseleave="inputHovering = false">
		<div class="mock-el-select-inner">
			<span v-if="!tagList || tagList.length === 0" class="mock-el-select-empty">{{this.placeholder}}</span>
			<template v-if="multiple">
				<el-tag
					size="mini"
					type="info"
					:closable="closable"
					:disable-transitions="true"
					v-for="(item, index) in viewTagList"
					:key="item.key"
					@close="handleTagClose(item, index)">
					{{ item[props.label] | cutString(wordNumber) }}
				</el-tag>
				<el-tag 
					:disable-transitions="true"
					v-if="tagList && tagList.length > 1 && collapseTags"
					size="mini"
					type="info">
					+{{ tagList.length - 1 }}
				</el-tag>
			</template>
			<span v-else class="mock-el-selec-label" :title="viewLabel">
				{{ viewLabel | cutString(wordNumber) }}
			</span>
		</div> 
		<span class="mock-el-select-suffix">
			<as-icon @click.native.stop="onClear" v-if="closeVisible" class="mock-el-select-icon mock-el-select-close" name="circle-close" is-element></as-icon>
			<as-icon v-show="!closeVisible" class="mock-el-select-icon mock-el-select-arrow" name="arrow-up" is-element></as-icon>
		</span>
	</div>
</template>
<script>
import AsIcon from '@/components/icon'
import UtilsMixins from '@/mixins/utils'
export default {
	name: 'mock-el-select',
	components: {
		AsIcon
	},
	mixins: [UtilsMixins],
	props: {
		multiple: {
			type: Boolean,
			default: true
		},
		collapseTags: Boolean,
		focus: Boolean,
		size: String,
		props: {
			type: Object,
			default: () => {
				return {
					label: 'label',
					id: 'id'
				}
			}
		},
		tagList: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default: false
		},
		wordNumber: {
			type: Number,
			default: 30
		},
		placeholder: String,
		closable: {
			type: Boolean,
			default: true,
		},
		clearable: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			inputHovering: false,
		}
	},
	computed: {
		classList() {
			const classPrefix = 'mock-el-select--';
			let result = [];
			if (this.collapseTags) {
				result.push(`${classPrefix}collapse`)
			}
			if (this.size) {
				result.push(`${classPrefix}${this.size}`)
			}
			if (this.focus) {
				result.push(`${classPrefix}focus`)
			}
			if (this.disabled) {
				result.push(`${classPrefix}disabled`)
			}
			return result;
		},
		viewLabel() {
			const { tagList, props }  = this;
			return tagList && tagList.length > 0 ? tagList[0][props.label] : '';
		},
		viewTagList() {
			if (!this.collapseTags) return this.tagList;
			const tagLength = this.tagList ? this.tagList.length : 0;
			return tagLength ? [this.tagList[0]] : [];
		},
		closeVisible() {
			return this.tagList && this.tagList.length && this.clearable && this.inputHovering;
		},
	},
	methods: {
		handleTagClose(item, index) {
			this.$emit('close', index);
		},
		onClear() {
			this.$emit('clear');
		},
	}
}
</script>

<style lang="scss">
	.mock-el-select_container {
		display: inline-block;
		width: 180px;
	}
	.mock-el-select {
		position: relative;
		padding: 0 30px 0 0;
		-webkit-appearance: none;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		box-sizing: border-box;
		color: #606266;
		font-size: inherit;
		min-height: 40px;
		line-height: 40px;
		outline: none;
		transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
		cursor: pointer;
	}
	.mock-el-selec-label {
		padding-left: 15px;
		font-size: 12px;
		color: #000;
	}
	.mock-el-select-suffix {
		position: absolute;
		height: 100%;
		right: 5px;
		top: 0;
		text-align: center;
		color: #c0c4cc;
		transition: all .3s;
	}
	.mock-el-select-icon {
		width: 25px;
		transform: rotateZ(180deg);
		transition: inherit;
	}
	.mock-el-select--focus .mock-el-select-icon {
		transform: rotateZ(0deg);
	}
	.mock-el-select--focus {
		border-color: #0ae;
	}
	.mock-el-select.mock-el-select--disabled {
		background-color: #F5F7FA;
		cursor: not-allowed;
	}
	.mock-el-select.mock-el-select--collapse {
		height: 40px;
	}
	.mock-el-select--mini {
		line-height: 28px;
		min-height: 28px;
	}
	.mock-el-select--mini.mock-el-select--collapse {
		height: 28px;
	}
	.mock-el-select--small {
		line-height: 30px;
		min-height: 30px;
	}
	.mock-el-select--small.mock-el-select--collapse {
		height: 30px;
	}
	.mock-el-select-inner {
		width: 100%;
		min-height: inherit;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.mock-el-select .el-tag.el-tag--info {
		margin: 2px 0 2px 6px;
		color: #222;
		border-color: transparent;
	}
	.mock-el-select-empty {
		font-size: 12px;
		padding-left: 15px;
		color: #bebebe;
	}
</style>
